import Splide from '@splidejs/splide';

export const initProductInstallation = () => {
  const InstallationSliderEl = document.querySelector(
    '[data-product-installation-steps-slider]'
  );

  new Splide(InstallationSliderEl, {
    type: 'slide',
    perPage: 1,
    perMove: 1,
    speed: 300,
    rewind: true,
    arrows: false,
    pagination: true,
    classes: {
      pagination: 'product-installation__slider-pagination splide__pagination',
      page: 'product-installation__slider-pagination-btn splide__pagination__page',
    },
  }).mount();
};
